(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fr-offer-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fr-offer-hero')) {
    customElements.define('fr-offer-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.setupMobileLayout(options);
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (this.slides.length < 2) return;
        this.current = 0;
        this.dots = Array.from(this.querySelectorAll('[data-go-to]'));
        this.toggle = this.querySelector('[data-toggle]');
        this.status = this.querySelector('[data-status]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify && Shopify.designMode);
        this.hovered = false;
        this.visible = true;
        this.editorSelected = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.current - 1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.current + 1, true), options);
        this.dots.forEach(dot => dot.addEventListener('click', () => this.show(Number(dot.dataset.goTo), true), options));
        this.toggle?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.sync();
        }, options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); }
        }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
        this.addEventListener('focusin', event => {
          if (event.target !== this.toggle) { this.paused = true; this.sync(); }
        }, options);
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1), true);
        }, options);
        this.addEventListener('touchstart', event => {
          this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }, { ...options, passive: true });
        this.addEventListener('touchend', event => {
          if (!this.touchStart) return;
          const x = event.changedTouches[0].clientX - this.touchStart.x;
          const y = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(x) > 55 && Math.abs(x) > Math.abs(y) * 1.5) this.show(this.current + (x < 0 ? 1 : -1), true);
        }, { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.sync();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorSelected = true;
          this.show(index, true);
        }, options);
        document.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.sync(); }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.1 });
        this.observer.observe(this);
        this.querySelector('.fr-offer-hero__controls').hidden = false;
        this.sync();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.shopObserver?.disconnect();
        this.shopResizeObserver?.disconnect();
        cancelAnimationFrame(this.shopFrame);
        this.shopFrame = null;
        this.classList.remove('is-mobile-in-view');
        this.controller?.abort();
        this.controller = null;
      }
      setupMobileLayout(options) {
        this.mobileMedia = matchMedia('(max-width: 749px)');
        this.siteHeader = document.getElementById('SiteHeader');
        const schedule = () => {
          if (this.shopFrame) return;
          this.shopFrame = requestAnimationFrame(() => {
            this.shopFrame = null;
            this.updateMobileLayout();
          });
        };
        this.mobileMedia.addEventListener('change', () => this.updateMobileLayout(), options);
        window.addEventListener('scroll', schedule, { ...options, passive: true, capture: true });
        window.addEventListener('resize', schedule, options);
        window.addEventListener('pageshow', schedule, options);
        window.visualViewport?.addEventListener('resize', schedule, options);
        window.visualViewport?.addEventListener('scroll', schedule, { ...options, passive: true });
        this.shopObserver = new IntersectionObserver(() => this.updateMobileLayout(), { threshold: [0, 1] });
        this.shopObserver.observe(this);
        if (typeof ResizeObserver !== 'undefined') {
          this.shopResizeObserver = new ResizeObserver(schedule);
          this.shopResizeObserver.observe(this);
          if (this.siteHeader) this.shopResizeObserver.observe(this.siteHeader);
        }
        this.updateMobileLayout();
      }
      updateMobileLayout() {
        if (this.siteHeader) {
          this.style.setProperty('--fr-site-header-height', `${this.siteHeader.getBoundingClientRect().height}px`);
        }
        const bounds = this.getBoundingClientRect();
        const viewportTop = window.visualViewport?.offsetTop || 0;
        const viewportBottom = viewportTop + (window.visualViewport?.height || window.innerHeight);
        const overlapsHero = bounds.bottom > viewportTop && bounds.top < viewportBottom;
        this.classList.toggle('is-mobile-in-view', this.mobileMedia.matches && overlapsHero);
      }
      show(index, userAction = false) {
        const next = (index + this.slides.length) % this.slides.length;
        const focused = document.activeElement;
        if (this.slides[this.current].contains(focused)) {
          this.dots[next].focus({ preventScroll: true });
          this.paused = true;
        }
        this.slides.forEach((slide, position) => {
          const active = position === next;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
          if (active) this.dots[position].setAttribute('aria-current', 'true');
          else this.dots[position].removeAttribute('aria-current');
        });
        this.current = next;
        if (userAction) {
          this.paused = true;
          this.status.textContent = this.dataset.statusLabel.replace('[current]', String(next + 1)).replace('[total]', String(this.slides.length));
        }
        this.sync();
      }
      sync() {
        clearTimeout(this.timer);
        const canPlay = !this.paused && !this.hovered && this.visible && !document.hidden && !this.motion.matches && !this.editorSelected;
        if (this.toggle) {
          this.toggle.hidden = this.motion.matches;
          this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
          this.toggle.setAttribute('aria-pressed', String(this.paused));
          this.toggle.querySelector('[data-play-icon]').hidden = !this.paused;
          this.toggle.querySelector('[data-pause-icon]').hidden = this.paused;
        }
        if (canPlay) this.timer = setTimeout(() => this.show(this.current + 1), Math.max(5000, Number(this.dataset.interval) || 7000));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
